import { ModalUpdateZoopContainer, ModalUpdateZoopTexts } from './style';
import { Button } from 'takeat-design-system-ui-kit';
import { useAuth } from 'context/AuthContext';
import React, { useState } from 'react';

import yellowAlert from '../../assets/img/alert-orange-icon.svg';

export const zoopKey = '@gddashboard:zoop';

export default function ModalUpdateZoop() {
  const { user } = useAuth();
  const [isClosedZoop, setIsClosedZoop] = useState(() => {
    return localStorage.getItem(zoopKey) === 'true';
  });

  const isShowingModal = 
    user?.access === "administrador" &&
    user?.establishment_id === null &&
    !isClosedZoop;

  function handleCloseModal() {
    setIsClosedZoop(true);
    localStorage.setItem(zoopKey, true);
  }

  function handleRedirectToForm() {
    const url = 'https://docs.google.com/forms/d/e/1FAIpQLSdpvsn5N2v6oewyXyLy3x2o3BkAWk2HF08yH7uaOubP9P8yKQ/viewform';
    window.open(url, '_blank');
    handleCloseModal();
  }

  return <ModalUpdateZoopContainer 
    open={isShowingModal}
    toggle={handleCloseModal}  
  >
    <main>
      <img src={yellowAlert} alt="Alerta sobre atualização de pagamento"/>
      <ModalUpdateZoopTexts>
        <h4>Estamos migrando nosso sistema de pagamentos</h4>
        <p>A Zoop, nossa atual provedora de pagamentos online, deixará de atender empresas integradas por meio de parceiros.</p>
        <section>
          <p>
            Por isso, estamos migrando para a Paytime, que oferece taxas mais vantajosas e integração completa.<br/>
            <span>As contas Zoop serão desativadas nesta semana.</span>
          </p>
        </section>
        <p>Preencha o formulário para continuar usando pagamentos online em sua loja.</p>
      </ModalUpdateZoopTexts>
    </main>
    <footer>
      <Button variant='text' customColor='#222' onClick={handleCloseModal}>Cancelar</Button>
      <Button variant='default' customColor='#FFB32F' onClick={handleRedirectToForm}>Preencher formulário</Button>
    </footer>
  </ModalUpdateZoopContainer>
}